module.exports = __webpack_public_path__ + "static/img/out3.21532ad9.png";